import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["prefixCls", "className", "panelDate", "monthLabel", "onSelected", "todayButton"];
import React, { useMemo } from 'react';
import { noop } from '@uiw/utils';
import "./style/caption.css";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function classnames() {
  for (var _len = arguments.length, arg = new Array(_len), _key = 0; _key < _len; _key++) {
    arg[_key] = arguments[_key];
  }
  return [...arg].filter(Boolean).join(' ').trim();
}
export function DatePickerCaption(props) {
  var {
      prefixCls = 'w-datepicker',
      className,
      panelDate = new Date(),
      monthLabel,
      onSelected = noop,
      todayButton
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  var renderMonth = useMemo(() => {
    var month = panelDate.getMonth();
    return monthLabel && monthLabel[month] || month + 1;
  }, [panelDate.toDateString(), monthLabel]);
  return /*#__PURE__*/_jsxs("div", _extends({
    className: classnames(prefixCls ? prefixCls + "-caption" : null, className)
  }, other, {
    children: [/*#__PURE__*/_jsx("div", {
      className: classnames(prefixCls ? prefixCls + "-caption-pane" : null, 'prev'),
      onClick: () => onSelected('prev')
    }), /*#__PURE__*/_jsx("div", {
      className: classnames(prefixCls ? prefixCls + "-caption-pane" : null, 'month'),
      onClick: () => onSelected('month'),
      children: renderMonth
    }), /*#__PURE__*/_jsx("div", {
      className: classnames(prefixCls ? prefixCls + "-caption-pane" : null, 'year'),
      onClick: () => onSelected('year'),
      children: panelDate.getFullYear()
    }), todayButton && /*#__PURE__*/_jsx("div", {
      className: classnames(prefixCls ? prefixCls + "-caption-today" : null),
      onClick: () => onSelected('today'),
      title: todayButton
    }), /*#__PURE__*/_jsx("div", {
      className: classnames(prefixCls ? prefixCls + "-caption-pane" : null, 'next'),
      onClick: () => onSelected('next')
    })]
  }));
}